import { enableGlobalNavIaRedesign } from '@gonfalon/dogfood-flags/dogfood-flags';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { IconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { getKeyboardShortcutLabel, KeyboardShortcut } from '../keyboardShortcuts';

import { useSidebarContext } from './useSidebarContext';

import styles from './SidebarToggle.module.css';

export function SidebarToggle({ 'data-sidebar-toggle': toggleId }: { 'data-sidebar-toggle'?: string }) {
  const sidebar = useSidebarContext();
  const redesign = enableGlobalNavIaRedesign();
  const label = redesign
    ? sidebar.isVisible
      ? msg('chrome.projectNavigation.collapse')
      : msg('chrome.projectNavigation.expand')
    : sidebar.isVisible
      ? 'Hide sidebar'
      : 'Show sidebar';

  return (
    <TooltipTrigger>
      <IconButton
        size="medium"
        variant="minimal"
        aria-label={label}
        data-sidebar-toggle={toggleId}
        icon={sidebar.isVisible ? 'sidebar-left-collapse' : 'sidebar-left-expand'}
        onPress={() => sidebar.toggle({ trigger: 'button' })}
      />
      <Tooltip placement={redesign && sidebar.isRail ? 'end' : 'bottom'}>
        <span className={styles.tooltip}>
          {redesign ? (
            <>
              <Message
                id={sidebar.isVisible ? 'chrome.projectNavigation.collapse' : 'chrome.projectNavigation.expand'}
              />
              <kbd>{getKeyboardShortcutLabel(KeyboardShortcut.TOGGLE_PROJECT_SIDEBAR)}</kbd>
            </>
          ) : sidebar.isVisible ? (
            <>
              <Message id="chrome.sidebar.hide" />
              <kbd>{getKeyboardShortcutLabel(KeyboardShortcut.TOGGLE_PROJECT_SIDEBAR)}</kbd>
            </>
          ) : (
            <>
              <Message id="chrome.sidebar.show" />
              <kbd>{getKeyboardShortcutLabel(KeyboardShortcut.TOGGLE_PROJECT_SIDEBAR)}</kbd>
            </>
          )}
        </span>
      </Tooltip>
    </TooltipTrigger>
  );
}
